
  <div id="popupReportContainer" class="report-container" 
  [style.visibility]="isLoading?'hidden':'visible'" ></div>
